export const textsGameGhatPage: string[] = [
    'ОБЩИЙ ЧАТ',
    'ОТПРАВИТЬ'
]